import { SxProps } from "@mui/material";

export const BOX_SHADOWS = {
  0: {
    boxShadow: "rgba(0, 0, 0, 0.16) 0px 1px 4px;",
  } as SxProps,
};
